import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

import Button from '../../Atoms/Button';

import { Container, Icon, Title, Description } from './styles';

interface ErrorStateProps {
  /** Mensagem do erro (se vazia, usa um texto padrão). */
  message?: string;
  /** Função para tentar novamente (recarregar a listagem). */
  onRetry?: () => void;
}

/**
 * Estado de erro do admin. Nomeia o problema e oferece a recuperação
 * ("tentar de novo") em vez de travar em loading infinito.
 */
const ErrorState: React.FC<ErrorStateProps> = ({ message, onRetry }) => {
  return (
    <Container role="alert">
      <Icon>
        <FiAlertTriangle size={32} />
      </Icon>
      <Title>Não foi possível carregar os dados</Title>
      <Description>
        {message || 'Ocorreu um erro ao buscar as informações. Tente novamente.'}
      </Description>
      {onRetry && (
        <Button type="button" onClick={onRetry}>
          Tentar novamente
        </Button>
      )}
    </Container>
  );
};

export default ErrorState;
